<template lang="pug">
  v-chip(outlined) {{ label }}
</template>

<script>
import { computed } from '@vue/composition-api'
import { injectRouteState } from '@iez/core'

export default {
  setup () {
    const routeState = injectRouteState()

    return {
      label: computed(
        () => routeState.typeLabel
      )
    }
  }
}
</script>
